/* eslint-disable */

import React from "react";
import { useState } from "react";
import styles from "./Navigation.module.scss";
import lateral from "./lateral.png";
import lateralWhite from "./lateral-white.png";

const Navigation = ({ selected, options, onChange }) => {
    const [isBurgerOpen, setBurger] = useState(false);

    function handleBurgerClick() {
        setBurger(!isBurgerOpen);
    }

    const burgerOpenStyle = isBurgerOpen ? styles.isBurgerOpen : " ";

    return (
        <div className={styles.container}>
            <div className={styles.fixedContainer}>
                <div className={styles.desktopContainer}>
                    <ul className={styles.menu} style={{ justifyContent: "flex-start" }}>
                        <li
                            className={styles.menuItem}
                            style={{ paddingLeft: 0 }}
                            data-href="https://www.lateral-inc.com/design.html">
                            <a
                                style={{ color: "rgba(0,0,0,0.6)" }}
                                href="https://www.lateral-inc.com/design.html">
                                Design
                            </a>
                        </li>
                        <li
                            className={styles.menuItem}
                            data-href="https://www.lateral-inc.com/technology.html">
                            <a href="https://www.lateral-inc.com/technology.html">Technology</a>
                        </li>
                        <li
                            className={styles.menuItem}
                            data-href="https://www.lateral-inc.com/products.html">
                            <a href="https://www.lateral-inc.com/products.html">Products</a>
                        </li>
                        <li
                            className={styles.menuItem}
                            data-href="https://www.lateral-inc.com/labs.html">
                            <a href="https://www.lateral-inc.com/labs.html">Labs</a>
                        </li>
                    </ul>

                    <a href="https://www.lateral-inc.com" className={styles.logoContainer}>
                        <img src={lateral} alt="" />
                    </a>

                    <ul className={styles.menu} style={{ justifyContent: "flex-end" }}>
                        <li
                            className={styles.menuItem}
                            data-href="https://www.lateral-inc.com/about.html">
                            <a href="https://www.lateral-inc.com/about.html">About</a>
                        </li>
                        <li
                            className={styles.menuItem}
                            data-href="https://www.lateral-inc.com/careers.html">
                            <a href="https://www.lateral-inc.com/careers.html">Careers</a>
                        </li>
                        <li
                            className={styles.menuItem}
                            data-href="https://www.lateral-inc.com/contact.html">
                            <a href="https://www.lateral-inc.com/contact.html">Contact</a>
                        </li>
                        <li
                            className={styles.menuItem + " " + styles.teamDance}
                            data-href="https://www.lateral-inc.com/happy-team-dancing.html">
                            <a href="https://www.lateral-inc.com/happy-team-dancing.html">
                                <img
                                    width="20"
                                    src="https://www.lateral-inc.com/assets/img/rabbit-black.png"
                                    alt=""
                                />
                            </a>
                        </li>
                        <li className={styles.menuItem} style={{ padding: 0, marginTop: "2px" }}>
                            <a
                                className={styles.icon + " " + styles.iconFacebook}
                                href="https://www.facebook.com/lateral.inc"
                                target="_blank"></a>
                        </li>
                    </ul>
                </div>
                <div className={styles.mobileContainer}>
                    <div className={styles.burgerContainer + " " + burgerOpenStyle}>
                        <div className={styles.burger} onClick={handleBurgerClick}>
                            <div className={styles.bar + " " + styles.topBar}></div>
                            <div className={styles.bar + " " + styles.bottomBar}></div>
                        </div>
                        <div className={styles.logoContainer}>
                            <a href="https://www.lateral-inc.com">
                                {isBurgerOpen ? (
                                    <img src={lateralWhite} alt="" />
                                ) : (
                                    <img src={lateral} alt="" />
                                )}
                            </a>
                        </div>
                    </div>
                    <ul className={styles.burgerMenu + " " + burgerOpenStyle}>
                        <li data-href="https://www.lateral-inc.com/design.html">
                            <a
                                style={{ color: "rgba(255,255,255,0.5)" }}
                                href="https://www.lateral-inc.com/design.html">
                                Design
                            </a>
                        </li>
                        <li data-href="https://www.lateral-inc.com/technology.html">
                            <a href="https://www.lateral-inc.com/technology.html">Technology</a>
                        </li>
                        <li data-href="https://www.lateral-inc.com/products.html">
                            <a href="https://www.lateral-inc.com/products.html">Products</a>
                        </li>
                        <li data-href="https://www.lateral-inc.com/labs.html">
                            <a href="https://www.lateral-inc.com/labs.html">Labs</a>
                        </li>

                        <li data-href="https://www.lateral-inc.com/about.html">
                            <a href="https://www.lateral-inc.com/about.html">About</a>
                        </li>
                        <li data-href="https://www.lateral-inc.com/careers.html">
                            <a href="https://www.lateral-inc.com/careers.html">Careers</a>
                        </li>
                        <li data-href="https://www.lateral-inc.com/contact.html">
                            <a href="https://www.lateral-inc.com/contact.html">Contact</a>
                        </li>
                        <li data-href="https://www.lateral-inc.com/happy-team-dancing.html">
                            <a href="https://www.lateral-inc.com/happy-team-dancing.html">
                                <img
                                    width="20"
                                    src="https://www.lateral-inc.com/assets/img/rabbit-black.png"
                                    alt=""
                                />
                            </a>
                        </li>
                        <li
                            style={{ padding: 0, marginTop: "2px" }}
                            className={styles.icon + " " + styles.iconFacebook}>
                            <a href="https://www.facebook.com/lateral.inc" target="_blank"></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Navigation;
